import React from "react";
import { useNavigate } from "react-router-dom";
import meetingIntelligenceIcon from "../../assets/images/meeting_intelligence_icon.png";
import teamCommunicationIcon from "../../assets/images/team_communication_icon.png";

function SourceSelection() {
  const navigate = useNavigate();

  return (
    <div className="container py-5 mt-4" style={{ maxWidth: "1400px" }}>
      <div className="text-center mb-5">
        <h2 className="fw-bold">How Do You Want to Get Started?</h2>
        <p className="text-muted mb-0 mt-2">
          Choose a source to begin. Connect meeting transcripts or team
          conversations and turn them into tasks and workflows.
        </p>
      </div>

      <div className="row g-4 justify-content-center">
        <div className="col-lg-6 col-md-6 col-12">
          <div
            className="card h-100 shadow-sm p-3"
            style={{
              borderRadius: "18px",
              minHeight: "220px",
              transition: "0.2s",
            }}
          >
            <div className="card-body d-flex flex-column align-items-center text-center">
              <div
                className="rounded-circle bg-secondary d-flex align-items-center justify-content-center mb-3 "
                style={{ width: "180px", height: "180px" }}
              >
                <img
                  src={meetingIntelligenceIcon}
                  alt="Meeting Intelligence Icon"
                  style={{ height: "314px", maxWidth: "none" }}
                />
              </div>

              <h5 className="fw-semibold mb-2">
                Convert Meetings & Recordings Into Action Items
              </h5>
              <p>Works with Granola, Otter, Fireflies, Fathom & Sembly etc.</p>

              <button
                className="btn btn-primary d-flex align-items-center justify-content-center w-100 px-4"
                style={{ maxWidth: "260px" }}
                onClick={() => navigate("/onboarding/note-taker/integrations")}
              >
                Get Started
                <i className="wb webconnect-arrow-right-circle ms-2 fs-6" />
              </button>
            </div>
            <div className="card-footer bg-transparent border-top pt-3">
              <ul className="list-unstyled mb-0">
                {[
                  "Turn meeting notes into actionable tasks automatically",
                  "Import notes from Granola, Otter AI, Fireflies AI, Fathom AI, and Sembly AI",
                  "Extract action items, decisions, and follow-ups instantly",
                  "Assign tasks to the right owners without manual effort",
                  "Sync actions with Asana, Jira, Trello, ClickUp, and more",
                  "Ensure every meeting results in measurable execution",
                ].map((text, i) => (
                  <li
                    key={i}
                    className="mb-2 d-flex align-items-start"
                    style={{ textAlign: "left" }}
                  >
                    <i
                      className="wb webconnect-check-circle text-success me-2 flex-shrink-0"
                      style={{ marginTop: "2px" }}
                    />
                    <span style={{ textAlign: "left", display: "block" }}>
                      {text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-12">
          <div
            className="card h-100 shadow-sm p-3"
            style={{
              borderRadius: "18px",
              minHeight: "220px",
              transition: "0.2s",
            }}
          >
            <div
              className="card-body d-flex flex-column align-items-center text-center"
              style={{
                maxHeight: "385px",
              }}
            >
              <div
                className="rounded-circle bg-secondary d-flex align-items-center justify-content-center mb-3"
                style={{ width: "180px", height: "180px" }}
              >
                <img
                  src={teamCommunicationIcon}
                  alt="Team Communication Icon"
                  style={{ height: "235px" }}
                />
              </div>

              <h5 className="fw-semibold mb-2">
                Convert Slack/Discord/Gmail Conversations Into Action Items
              </h5>
              <p>Transform team conversations into executable workflows.</p>

              <button
                className="btn btn-primary d-flex align-items-center justify-content-center w-100 px-4"
                style={{ maxWidth: "260px" }}
                onClick={() =>
                  navigate("/onboarding/team-communication/integrations")
                }
              >
                Get Started
                <i className="wb webconnect-arrow-right-circle ms-2 fs-6" />
              </button>
            </div>
            <div className="card-footer bg-transparent border-top pt-3">
              <ul className="list-unstyled mb-0">
                {[
                  "Detect tasks hidden inside chat conversations",
                  "Convert messages into actionable work items",
                  "Assign ownership directly from discussions",
                  "Sync tasks with Asana, Jira, Trello, and more",
                  "Capture decisions without manual tracking",
                  "Ensure important requests never get overlooked",
                ].map((text, i) => (
                  <li
                    key={i}
                    className="mb-2 d-flex align-items-start"
                    style={{ textAlign: "left" }}
                  >
                    <i
                      className="wb webconnect-check-circle text-success me-2 flex-shrink-0"
                      style={{ marginTop: "2px" }}
                    />
                    <span style={{ textAlign: "left", display: "block" }}>
                      {text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SourceSelection;
